//@ts-nocheck
import React, { useEffect, useState } from "react";
import { ISTWWidgetCustomisation } from "widget-models/lib/models/STW/stw.interface";
import GameRules from "../../GameRules";
import Background from "../../SlotMachine/components/Background/Background";
import Header from "../../SlotMachine/components/Header/Header";
import PoweredByBik from "../../SlotMachine/components/PowereByBik/PoweredByBik";
import AssuredGifts from "../components/AssuredGifts";
import Wheel from "../components/Wheel";
import './Game.css';
const SpinWheel = () => {
    const [showGameRules, setShowGameRules] = useState<boolean>(false);
    const widgetCustomisation = {
        spikesCount: 6,
        segmentColor1: '#B7E5FF',
        segmentColor2: '#353535',
        spinnerColor: '#F9CD32'
    }

    useEffect(() => {
        if (window.gtag) {
            window.gtag('event', 'conversion', { 'send_to': 'AW-666593854/j5cbCOa12ZMYEL7U7b0C' });
        }
    }, [])

    const onUpadteShowGameRulesState = (flag: boolean) => {
        setShowGameRules(flag)
    }
    return (
        <Background>
            <Header />
            <Wheel widgetCustomisation={widgetCustomisation as ISTWWidgetCustomisation} onSpinHandle={() => { }} />
            <PoweredByBik onTandCClickHandle={onUpadteShowGameRulesState} />
            {showGameRules && <GameRules onCloseHandle={onUpadteShowGameRulesState} />}
        </Background>
    )
}
export default SpinWheel;

